<div class="live-sources-grid" aria-live="polite">
  @for (source of sources; track source.id) {
    <evrideo-live-source-card
      [source]="source"
      (delete)="onDelete(source.id)"
    ></evrideo-live-source-card>
  } @empty {
    <div class="live-sources-grid__empty">
      <p>No live sources match your criteria</p>
    </div>
  }
</div>
